var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrainings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.272705 1.96968L0.272706 0.272705H1.96968H8.75815H10.4551H24.0298H25.7268L25.7272 0.272706V1.96968H25.7268V8.75756H25.7278V10.4545H25.7268V24.0303H25.7272V25.7272L25.7268 25.7272H24.0298H10.4551H8.75815H1.96968H0.272706L0.272705 24.0303V1.96968ZM1.96968 1.96968V24.0303H8.75815V10.4545V8.75756V1.96968L1.96968 1.96968ZM10.4551 1.96968V8.75756H24.0298V1.96968L10.4551 1.96968ZM10.4551 24.0303V10.4545H24.0298V24.0303L10.4551 24.0303Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrainings);
export default __webpack_public_path__ + "static/media/trainings.84c153c935d943899755a1a349ba6ce3.svg";
export { ForwardRef as ReactComponent };